import { derived, writable } from 'svelte/store';

export const innerWidth = writable(1440);

export const screen = derived(innerWidth, (innerWidth) => {
    if (innerWidth < 768) {
        return 'mobile';
    } else if (innerWidth < 1024) {
        return '768';
    } else if (innerWidth < 1280) {
        return '1024';
    } else if (innerWidth < 1920) {
        return '1280';
    } else if (innerWidth < 2550) {
        return '1920';
    } else {
        return '2560';
    }
});
